import React from 'react'

const OurValuesData =  [
{
    id: 1,
    title: 'CHAUFER SERVICES',
    detail: 'Lorem ipsum dolor sit amet consectetur. Dignissim venenatis urna gravida elit.',
},
{
    id: 2,
    title: 'TAILORED INTERACTION',
    detail: 'Lorem ipsum dolor sit amet consectetur. Dignissim venenatis urna gravida elit.',
},
{
    id: 3,
    title: 'AIRPORT TRANSFERS',
    detail: 'Lorem ipsum dolor sit amet consectetur. Dignissim venenatis urna gravida elit.',
},
{
    id: 4,
    title: 'EASY ONLINE BOOKING',
    detail: 'Lorem ipsum dolor sit amet consectetur. Dignissim venenatis urna gravida elit.',
},

]
export default OurValuesData